
import { defineComponent } from 'vue';
import BgImage from '@/views/public/landingpage/components/freelancer/BgImage.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import useFreelancerLandingPage from '@/views/public/landingpage/components/freelancer/useFreelancerLandingPage';
import LPBGArrow from '@/views/public/landingpage/components/LPBgArrow.vue';

export default defineComponent({
  name: 'FreelancerFeatures',
  components: { BCXMarkdown, BgImage, LPBGArrow },
  setup() {
    const { tl } = useFreelancerLandingPage();

    return { tl };
  }
});
